<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：Copyright
 *
 * 作成者：2021/11/22 ノア）虞
 * 最終修正者：2021/11/22 ノア）虞
 *
 -->
<template>
  <div class="copyright">
    <span>© Transtron Inc. 2023</span>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Copyright'
})
export default class Copyright extends Vue {}
</script>

<style scoped lang="scss">
.copyright {
  padding: 0 16px;
  margin: 20px 0 12px 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}
</style>
